module.exports = __webpack_public_path__ + "img/client-area.bd23c9cd.jpg";